import ImapIcon from 'assets/chat/IMail.svg';
import InstagramIcon from 'assets/chat/badgeIcon/Instagram.svg';
import MessangerIcon from 'assets/chat/badgeIcon/Messanger.svg';
import WhatsAppIcon from 'assets/chat/badgeIcon/WhatsApp.svg';

/**
 * Platform color mappings for consistent branding
 */
export const PLATFORM_COLORS = {
  facebook: '#2d6cdf',
  instagram: '#e1306c',
  whatsapp: '#25d366',
  imap: '#0277ff',
};

export const PLATFORM_CONFIG = {
  whatsapp: {
    icon: WhatsAppIcon,
    name: 'WhatsApp',
    badgeClass: '',
    platformClass: 'whatsapp',
    color: PLATFORM_COLORS.whatsapp,
  },
  instagram: {
    icon: InstagramIcon,
    name: 'Instagram',
    badgeClass: 'instaIcon',
    platformClass: 'instagram',
    color: PLATFORM_COLORS.instagram,
  },
  facebook: {
    icon: MessangerIcon,
    name: 'Messenger',
    badgeClass: 'fbIcon',
    platformClass: 'facebook',
    color: PLATFORM_COLORS.facebook,
  },
  imap: {
    icon: ImapIcon,
    name: 'Email',
    badgeClass: 'ImapIcon',
    platformClass: 'imap',
    bg: PLATFORM_COLORS.imap,
    color: PLATFORM_COLORS.imap,
  },
};

export const formatUnreadCount = (count) => {
  if (count >= 100) return '99+';
  return count;
};

export const formatChatListUnreadCount = (count) => {
  if (count >= 100) return '99+';
  return count;
};
